//Please add the language resource
const area = {
  provinceCode: 'provinceCode',
  provinceName: 'provinceName',
  cityCode: 'cityCode',
  cityName: 'cityName',
  distrinctCode: 'distrinctCode',
  distrinctName: 'distrinctName',
};
export default area



// WEBPACK FOOTER //
// ./src/page/mdm/area/lang/area.en.js